import { z } from 'zod';
import { Translations } from 'types/Common';
import { AdminDiscount } from 'store/admin-discounts';
import {
  discountsFiltersSchema,
  discountsWithStatsFiltersSchema,
} from './discounts.schemas';

export type DiscountTranslations = Translations<{
  title: string;
  teaser: string;
}>;

export const discountStatuses = [
  'draft',
  'active',
  'inactive',
  'expired',
] as const;
export type DiscountStatus = (typeof discountStatuses)[number];

export const availabilityStatuses = ['enabled', 'disabled'] as const;
export type AvailabilityStatus = (typeof availabilityStatuses)[number];

export const discountPackages = ['basic', 'premium', 'internal'] as const;
export type DiscountPackage = (typeof discountPackages)[number];

export const discountOfferTypes = [
  'PERCENTAGE',
  'FIXED',
  'SPECIAL_OFFER',
] as const;
export type DiscountOfferType = (typeof discountOfferTypes)[number];

export const discountCurrencies = [
  'EUR',
  'GBP',
  'PLN',
  'NOK',
  'CHF',
  'SEK',
  'DKK',
  'CZK',
  'TRY',
  'RON',
] as const;
export type DiscountCurrency = (typeof discountCurrencies)[number];

export type Discount = Pick<
  AdminDiscount,
  | 'id'
  | 'name'
  | 'supplier'
  | 'priority'
  | 'status'
  | 'image'
  | 'countries'
  | 'cities'
  | 'categories'
  | 'validFrom'
  | 'validTo'
  | 'publishedAt'
  | 'translations'
  | 'type'
  | 'discountedPercentage'
  | 'discountedFixed'
  | 'currency'
  | 'averageBasketSize'
  | 'averageSaving'
> & { isEnabled: boolean };

export type DiscountWithStats = Pick<
  AdminDiscount,
  | 'id'
  | 'name'
  | 'packages'
  | 'supplier'
  | 'validFrom'
  | 'validTo'
  | 'favoritesCount'
  | 'viewsCount'
  | 'uniqueViewsCount'
  | 'isUniqueCode'
> & { isEnabled: boolean };

export type DiscountsFilters = z.infer<typeof discountsFiltersSchema>;

export type DiscountsWithStatsFilters = z.infer<
  typeof discountsWithStatsFiltersSchema
>;
